// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/airspace-classes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/airspace-classes/airspace-classes.js';

mount([g0]);
